import { tagularData, resetTagularData } from '../tagular'
import {
  TagularEventFields,
  TagularTrackingService,
} from '../tracking/TagularTrackingService'
import {
  AlfieBaseEvent,
  AlfieExperience,
  AlfieRateSelectedEvent,
  AlfieRatesDisplayedEvent,
  ALFIE_EXPERIENCE,
  EventName,
  FormName,
} from '@mortgage-pos/types'

const FORM_NAME_BY_EXPERIENCE: Record<AlfieExperience, FormName> = {
  [ALFIE_EXPERIENCE.simpleV2]: FormName.SimpleV2Application,
}

export type AlfieTrackingContext = {
  experience: AlfieExperience
  formId: string
  pageName: string
  stepNumber: number
}

type AlfieEventFields<E extends AlfieBaseEvent> = Omit<E, keyof AlfieBaseEvent>

class AlfieTrackingService extends TagularTrackingService {
  alfieRatesDisplayed(context: AlfieTrackingContext) {
    this.emitAlfie<AlfieRatesDisplayedEvent>(
      EventName.AlfieRatesDisplayed,
      context,
      {}
    )
  }

  alfieRateSelected(context: AlfieTrackingContext) {
    this.emitAlfie<AlfieRateSelectedEvent>(
      EventName.AlfieRateSelected,
      context,
      {}
    )
  }

  private emitAlfie<E extends AlfieBaseEvent>(
    eventName: EventName,
    { experience, formId, pageName, stepNumber }: AlfieTrackingContext,
    fields: AlfieEventFields<E>
  ) {
    if (!formId) return
    // TS cannot relate Omit<E, base> to {experience} & Omit<E, base | experience>
    // for a generic E, so the reassembly is asserted here once.
    const payload = { experience, ...fields } as TagularEventFields<E>
    this.emit<E>(
      eventName,
      {
        formId,
        formName: FORM_NAME_BY_EXPERIENCE[experience],
        pageName,
        stepNumber,
      },
      payload
    )
  }
}

export const alfieTrackingService = new AlfieTrackingService()

export function alfieTrackingData(key?: EventName) {
  return tagularData(key)
}

export function resetAlfieTrackingData() {
  resetTagularData()
}
